/* ============================================================================
   SVNTY — THE BARS (one module for every bar born on a scroll)
   SVNTY, 2026-10-02, Part24 (03_design/audits/giftcard_part24/STICKY_SYSTEM_S.md §3). Classic deferred script, no
   module, no dependencies, guarded (`window.SvntyBars`), ASCII only.

   THE CONTRACT
     Declarative:  <div data-svnty-bar="gift" data-bar-edge="top|bottom" data-bar-sentinel="#id" data-bar-until="#id2" data-bar-band="8">
                   (data-bar-until, P25: the bar lets go once that second sentinel has passed under the slab)
     Code:         SvntyBars.register({ el, sentinel, edge, band, on: function (state) {} }) / .unregister(el) / .refresh()
   A bar is ON once its sentinel has passed under the slab (the sentinel's top <= the slab's visible bottom) and OFF again
   once the sentinel is `band` px back below it: a dead band, so momentum that stops on the line never flickers.
   The module writes `data-bar="on|off"` on the bar (ONE attribute per crossing, never a length during a gesture), keeps
   `html[data-bars~=name]`, dispatches `svnty:bar` {name, on} on the bar, and publishes `--svnty-bars-top` (the sum of the
   shown top bars' heights, measured at rest) for the sticky asides that must clear them (`.svnty-stick`).

   THE PUMP: ONE passive scroll + scrollend + resize + pageshow + `svnty:slab` + a ResizeObserver on the body -> ONE rAF ->
   per bar ONE rect read (its sentinel) against the slab's bottom (the slab's own rect top + `__svntyHeadstack.h()`, never
   getComputedStyle per frame). Nothing listens until the first bar registers.

   THE SLAB MOUNT (P26-1, the owner on the iPhone 2026-10-02: "with the keyboard up on THEIR EMAIL the gift bar stays pinned
   while the header scrolls away"): a top bar is MOVED INTO the slab (`.svnty-headstack__inner`, absolute at `top: 100%`, under
   the header in the slab's own stacking), so ONE transform carries the header and the bar: the slab's slide (the announcement
   bar parking and returning), the top zone, a door's park, and the iOS keyboard's pan of the visual viewport. The bar has no
   keyboard behaviour of its own any more (the P24 `--svnty-vv-y` follow is gone): it obeys the headstack's law, whatever that
   law is, because it is painted with the slab and can never be painted without it (the R2 refuter's P2-3 direction: the loose
   frames on a jump into the top zone end with it). A bar remembers its home (the section it came from): a section the editor
   re-renders or unloads takes its hoisted bar with it (scan).

   The motion lives in svnty-bars.css on the tokens (--svnty-spring*, --svnty-exit*); this file only flips states. The
   first state after a load (a restored scroll) lands without motion (`.is-instant` for one frame).
   ============================================================================ */
/* THE KEYBOARD RULE (lead, 2026-10-02 23:40): the header slab and every bar mounted in it are ONE slab that scrolls with the page under the iOS keyboard (they leave together, never pinned apart); doors and sheets are input surfaces and follow the keyboard (visualViewport). */   /* moved under the banner, P28 lane E (REFUTE_P26-1_R2 P3-3) */
(function () {
  'use strict';
  if (window.SvntyBars) return;

  var root = document.documentElement;
  var bars = [];
  var frame = 0;
  var wired = false;

  function slabBottom() {
    var hs = window.__svntyHeadstack;
    var slab = document.querySelector('.svnty-headstack');
    var h = hs && typeof hs.h === 'function' ? hs.h() : 0;
    if (!slab) return h;
    var top = slab.getBoundingClientRect().top;
    return Math.max(0, top) + h;
  }

  function resolve(sel, el) {
    if (!sel) return null;
    if (typeof sel !== 'string') return sel;
    try { return document.querySelector(sel) || (el && el.querySelector(sel)); } catch (e) { return null; }
  }

  function publishTop() {
    var sum = 0;
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (b.on && b.edge === 'top') sum += b.height;
    }
    root.style.setProperty('--svnty-bars-top', sum + 'px');
  }

  function setState(b, on, instant) {
    if (b.on === on) return;
    b.on = on;
    if (instant) {
      b.el.classList.add('is-instant');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { b.el.classList.remove('is-instant'); }); });
    }
    b.el.setAttribute('data-bar', on ? 'on' : 'off');
    var names = (root.getAttribute('data-bars') || '').split(/\s+/).filter(function (n) { return n && n !== b.name; });
    if (on) names.push(b.name);
    if (names.length) root.setAttribute('data-bars', names.join(' ')); else root.removeAttribute('data-bars');
    publishTop();
    if (typeof b.cb === 'function') { try { b.cb(on ? 'on' : 'off'); } catch (e) { /* a bar's own callback never stops the pump */ } }
    try { b.el.dispatchEvent(new CustomEvent('svnty:bar', { bubbles: true, detail: { name: b.name, on: on } })); } catch (e) { /* old engines */ }
  }

  function evaluate(instant) {
    frame = 0;
    if (!bars.length) return;
    var line = slabBottom();
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (!b.sentinel || !b.sentinel.isConnected) { b.sentinel = resolve(b.sentinelSel, b.el); if (!b.sentinel) continue; }
      /* a sentinel with no box (display:none, an empty div the theme hides) is never read as "passed": the bar stays off */
      if (!b.sentinel.getClientRects().length) { setState(b, false, instant || b.first); b.first = false; continue; }
      /* P28 lane E (gift refute P3-8): a bar the page does not draw at this width (the gift bar is display:none from 990) is never
         ON, so html[data-bars~=name] and --svnty-bars-top never name a bar nobody can see */
      if (!b.el.getClientRects().length) { setState(b, false, instant || b.first); b.first = false; continue; }
      var y = b.sentinel.getBoundingClientRect().top;
      var on = b.on ? !(y >= line + b.band) : (y <= line);
      /* P25 (the gift refuter's P2-2): an optional end sentinel (data-bar-until): once IT has passed under the slab the bar lets go,
         with the same dead band, so a top bar never rides over what follows its block (the desk card lets go at the form's foot). */
      if (on && b.untilSel) {
        if (!b.until || !b.until.isConnected) b.until = resolve(b.untilSel, b.el);
        if (b.until && b.until.getClientRects().length) {
          var u = b.until.getBoundingClientRect().top;
          if (b.on ? (u <= line - b.band) : (u <= line)) on = false;
        }
      }
      /* P25 (P2-3): in the top zone the slab re-enters by its own transform; a bar standing at the parked line would hang alone for
         those frames, so the top zone drops every top bar at once (the card is in view there anyway). */
      if (on && b.edge === 'top' && window.__svntyHeadstack && typeof window.__svntyHeadstack.atTop === 'function' && window.__svntyHeadstack.atTop()) { on = false; instant = true; }
      setState(b, on, instant || b.first);
      b.first = false;
    }
  }

  function schedule() { if (!frame) frame = window.requestAnimationFrame(function () { evaluate(false); }); }

  function measure() {
    for (var i = 0; i < bars.length; i++) bars[i].height = bars[i].el.offsetHeight || 0;
    publishTop();
    schedule();
  }

  function wire() {
    if (wired) return;
    wired = true;
    window.addEventListener('scroll', schedule, { passive: true });
    if ('onscrollend' in window) window.addEventListener('scrollend', schedule, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('pageshow', function () { evaluate(true); });
    document.addEventListener('svnty:slab', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
  }

  function register(opts) {
    if (!opts || !opts.el) return null;
    for (var i = 0; i < bars.length; i++) if (bars[i].el === opts.el) return bars[i];
    var el = opts.el;
    var b = {
      el: el,
      name: opts.name || el.getAttribute('data-svnty-bar') || 'bar',
      edge: opts.edge || el.getAttribute('data-bar-edge') || 'top',
      band: typeof opts.band === 'number' ? opts.band : (parseFloat(el.getAttribute('data-bar-band')) || 8),
      sentinelSel: opts.sentinel || el.getAttribute('data-bar-sentinel'),
      sentinel: null,
      untilSel: opts.until || el.getAttribute('data-bar-until') || null,
      until: null,
      cb: opts.on,
      on: null,
      first: true,
      height: el.offsetHeight || 0,
      home: null
    };
    if (!el.hasAttribute('data-bar-edge')) el.setAttribute('data-bar-edge', b.edge);
    /* THE SLAB MOUNT: a top bar lives in the slab (one transform with the header); its home is kept for the editor's re-renders */
    var inner = b.edge === 'top' ? document.querySelector('.svnty-headstack__inner') : null;
    if (inner && el.parentNode !== inner) { b.home = el.parentNode; inner.appendChild(el); }
    b.sentinel = resolve(b.sentinelSel, el);
    bars.push(b);
    wire();
    evaluate(true);
    measure();
    return b;
  }

  function unregister(el) {
    bars = bars.filter(function (b) {
      if (b.el !== el) return true;
      var names = (root.getAttribute('data-bars') || '').split(/\s+/).filter(function (n) { return n && n !== b.name; });
      if (names.length) root.setAttribute('data-bars', names.join(' ')); else root.removeAttribute('data-bars');
      return false;
    });
    publishTop();
  }

  function scan() {
    /* a section re-rendered or unloaded by the editor leaves its old bar detached, or (hoisted into the slab) homeless: drop it first */
    bars.slice().forEach(function (b) {
      if (b.el.isConnected && !(b.home && !b.home.isConnected)) return;
      if (b.el.parentNode) b.el.parentNode.removeChild(b.el);
      unregister(b.el);
    });
    var nodes = document.querySelectorAll('[data-svnty-bar]');
    for (var i = 0; i < nodes.length; i++) register({ el: nodes[i] });
  }

  window.SvntyBars = { register: register, unregister: unregister, refresh: function () { measure(); evaluate(false); }, scan: scan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function () { window.setTimeout(scan, 0); });
})();
